import { render, staticRenderFns } from "./stepheader.vue?vue&type=template&id=2794d2f4"
import script from "./stepheader.vue?vue&type=script&lang=js"
export * from "./stepheader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Repos\\StopRiparo_Piattaforma\\Piattaforma.Client\\wwwroot\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2794d2f4')) {
      api.createRecord('2794d2f4', component.options)
    } else {
      api.reload('2794d2f4', component.options)
    }
    module.hot.accept("./stepheader.vue?vue&type=template&id=2794d2f4", function () {
      api.rerender('2794d2f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/ticket/views/stepheader.vue"
export default component.exports